export const theme = {
  colors: {
    primary: '#2975ba',
    secondary: '#1a5788',
    light: 'var(--bs-gray-100)',
    dark: '#343a40',
    success: '#4caf50',
    telegram: '#0088cc',
    telegramHover: '#006699',
    positive: '#28a745',
    negative: '#dc3545',
    headerBg: '#ffffff',
  },
  dimensions: {
    headerHeight: '70px'
  },
  breakpoints: {
    mobile: '768px',
    tablet: '992px',
    desktop: '1200px',
  },
  zIndex: {
    header: 1000,
    modal: 9999,
    backToTop: 99,
    loader: 9999,
  },
  typography: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  shadows: {
    card: '0 5px 15px rgba(0,0,0,0.1)',
    cardHover: '0 15px 30px rgba(0,0,0,0.15)',
    header: '0 2px 4px rgba(0,0,0,0.1)',
  },
  transitions: {
    default: 'all 0.3s ease',
    transform: 'transform 0.3s',
    boxShadow: 'box-shadow 0.3s',
    background: 'background-color 0.3s',
  },
  borderRadius: {
    default: '10px',
    button: '50px',
    small: '5px',
    large: '15px',
  },
}

export type Theme = typeof theme